import React from "react";

import { Paper, Skeleton, Stack } from "@components/base";

const EntityEditorSkeleton: React.FC = () => (
  <Paper variant="outlined">
    <Stack spacing={3}>
      <Skeleton variant="rectangular" height={50} />
    </Stack>
  </Paper>
);

export default EntityEditorSkeleton;
